import React, { useEffect, useState } from 'react';
import { Device } from "../typings";
import { Align, Row } from "../components/Flex";
import { fetchUserDevices } from "./users-api";
import { useApi } from "../api-context";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import { activateDevice, deactivateDevice, deleteDevice } from "../devices/devices-api";
import UserDeviceRow from "./UserDeviceRow";

function UserDevicesPage() {
    const api = useApi();

    const { id } = useParams();

    const [devices, setDevices] = useState<Device[]>([]);

    const loadDevices = () => {
        fetchUserDevices(api, Number(id))
            .then(res => {
                setDevices(res);
            })
            .catch((reason) => {
                if (reason !== 'Unauthorized') {
                    toast.error('Failed to load devices');
                }
            });
    };

    const onActivate = (id: string) => {
        activateDevice(api, id)
            .then(() => {
                loadDevices();
                toast.success('Activated device')
            })
            .catch(() => toast.error('Failed to activate device'));
    };

    const onDeactivate = (id: string) => {
        deactivateDevice(api, id)
            .then(() => {
                loadDevices();
                toast.success('Deactivated device')
            })
            .catch(() => toast.error('Failed to deactivate device'));
    };

    const onDelete = (id: string) => {
        deleteDevice(api, id)
            .then(() => {
                loadDevices();
                toast.success('Removed device')
            })
            .catch(() => toast.error('Failed to remove device'));
    };


    useEffect(() => {
        loadDevices();
    }, []);

    const renderColumnHeader = (title: string, prop?: string, flex?: number) => {
        return (
            <div style={{ flex, display: 'flex' }}>
                <div className="column-header">
                    <div>{title}</div>
                </div>
            </div>
        );
    }

    return (
        <>
            <div className="page-container drill-files-page">
                <Row gap={8} style={{marginBottom: '32px'}} align={Align.SPACE_BETWEEN} >
                    <div style={{ flex: 1 }} className="main-title">
                        User devices
                    </div>
                </Row>
                <Row style={{ padding: '12px 16px' }}>
                    {renderColumnHeader('Id', 'id', 4)}
                    {renderColumnHeader('OS', 'operatingSystem', 1)}
                    {renderColumnHeader('Status', 'active', 1)}
                    <div style={{ width: '28px' }}/>
                </Row>
                <div className="content-container" style={{ marginBottom: '32px', gap: '4px' }}>
                    {devices.map((device) => (
                        <UserDeviceRow
                            key={device.id}
                            device={device}
                            onDelete={onDelete}
                            onActivate={onActivate}
                            onDeactivate={onDeactivate}
                        />
                    ))}
                </div>
            </div>
        </>
    );
}
export default UserDevicesPage;
